/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authenticating_AccessInputs */

const en_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticating Access`)
};

const es_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticando acceso`)
};

const fr_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification de l'accès`)
};

const de_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugang wird authentifiziert`)
};

const ja_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセスを認証中`)
};

const zh_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证访问权限中`)
};

const ar_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري مصادقة الوصول`)
};

const id_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengautentikasi Akses`)
};

const it_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticazione Accesso in Corso`)
};

const ru_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка доступа`)
};

const pt_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticando Acesso`)
};

const ko_authenticating_access = /** @type {(inputs: Authenticating_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`접근 권한 인증 중`)
};

/**
* | output |
* | --- |
* | "Authenticating Access" |
*
* @param {Authenticating_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const authenticating_access = /** @type {((inputs?: Authenticating_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authenticating_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authenticating_access(inputs)
	if (locale === "es") return es_authenticating_access(inputs)
	if (locale === "fr") return fr_authenticating_access(inputs)
	if (locale === "de") return de_authenticating_access(inputs)
	if (locale === "ja") return ja_authenticating_access(inputs)
	if (locale === "zh") return zh_authenticating_access(inputs)
	if (locale === "ar") return ar_authenticating_access(inputs)
	if (locale === "id") return id_authenticating_access(inputs)
	if (locale === "it") return it_authenticating_access(inputs)
	if (locale === "ru") return ru_authenticating_access(inputs)
	if (locale === "pt") return pt_authenticating_access(inputs)
	return ko_authenticating_access(inputs)
});